













































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Card from '@/components/default/Card.vue';
import notificationService from '@/services/notificationService';
import { DxForm, DxSimpleItem, DxGroupItem, DxLabel, DxItem } from 'devextreme-vue/form';
import { DxSwitch, DxTabs, DxTextBox } from 'devextreme-vue';
import SaveBar from '@/modules/shared/savebar/SaveBar.vue';
import {
  MailTemplatesClient,
  MailTemplateDto,
  MailTemplateType,
  SettingsUpdateCommand,
  Settings,
  TaskTemplatesClient,
  TaskTemplateDto,
  SettingsClient,
  InvoicingSettings,
  PlanningSettings,
} from '@/data/web-api-client';
import { SecurityConfig } from '@/installationConfig';

@Component({
  components: {
    Card,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxTextBox,
    DxItem,
    DxLabel,
    SaveBar,
    DxTabs,
    DxSwitch,
  },
})
export default class SettingsPage extends Vue {
  public formData: SettingsUpdateCommand = new SettingsUpdateCommand({
    defaultMargin: 0,
    defaultHourRate: 0,
    defaultTermsOfPayment: 0,
    rentalMailingTemplate: '',
    warrantySetupTemplate: '',
    checkinAtWorkTemplate: '',
    paymentReminderTemplate: '',
    safetyHealthEnvironmentPlanTemplate: '',
    riskAnalysisTemplate: '',
    quotationSmsTemplate: '',
    invoiceSmsTemplate: '',
    phaseArticleId: '',
    cleanUpArticleId: '',
    cleanUpPerUnitArticleId: '',
    wasteDisposalArticleId: '',
    defaultWasteDisposalPercentage: undefined,
    defaultCleanUpPercentage: undefined,
    wasteDisposalPerUnitArticleId: '',
    invoicing: new InvoicingSettings({
      reminderEnabled: false,
      firstReminderTemplateId: '',
      secondReminderTemplateId: '',
      secondReminderInDays: 14,
    }),
    planning: new PlanningSettings({
      intervalMessageReportDate: 0,
    }),
    summaryInCategories: false,
  });
  public financeFormData = {
    summaryInCategories: false,
  };

  public dirty: boolean = false;
  public saving: boolean = false;
  invoicingMailTemplates: MailTemplateDto[] = [];
  taskTemplates: TaskTemplateDto[] = [];
  public initialised: boolean = false;
  navIndex: number = 0;

  async created() {
    this.loadData();
    this.formData.init(this.settings);
    this.financeFormData.summaryInCategories = this.formData.summaryInCategories!;
  }

  async loadData() {
    this.invoicingMailTemplates = await new MailTemplatesClient(undefined, this.$axios).getAll(MailTemplateType.Invoicing);
    this.taskTemplates = await new TaskTemplatesClient(undefined, this.$axios).getAll();

    setTimeout(() => {
      this.initialised = true;
    }, 100);
  }

  public async saveSettings() {
    try {
      await new SettingsClient(undefined, this.$axios).update(this.formData);
      this.initialised = false;
      this.$store.dispatch('settings/load');
      setTimeout(() => {
        this.initialised = true;
      }, 100);
      notificationService.saved();
      this.dirty = false;
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  get templateOptions() {
    return {
      dataSource: this.invoicingMailTemplates,
      valueExpr: 'id',
      displayExpr: 'name',
    };
  }

  get taskTemplateOptions() {
    return {
      dataSource: this.taskTemplates,
      valueExpr: 'id',
      displayExpr: 'name',
      searchExpr: 'name',
      searchEnabled: true,
    };
  }

  get articlesOptions() {
    return {
      dataSource: this.articles,
      valueExpr: 'id',
      displayExpr: 'name',
      searchExpr: 'name',
      searchEnabled: true,
      showClearButton: true,
    };
  }

  get articles() {
    return this.$store.getters['articles/items'];
  }

  get settings(): Settings {
    return this.$store.getters['settings/data'];
  }

  get navbarItems() {
    var items = [
      { icon: 'fas fa-info-circle', text: 'Info', visible: true },
      {
        icon: 'fas fa-euro-sign',
        text: 'Aan- & Verkoop',
        allowedRole: SecurityConfig.administratorGroup,
      },
    ];

    return items;
  }

  @Watch('settings', { deep: true })
  onSettingsChanged() {
    this.formData.init(this.settings);
    // this.dirty = false;
  }

  @Watch('formData', { deep: true })
  onFormDataChanged() {
    if (this.initialised) {
      this.dirty = true;
    }
  }

  @Watch('financeFormData', { deep: true })
  onfinanceFormDataChanged() {
    if (!this.initialised) return;

    this.dirty = true;
    this.formData.summaryInCategories = this.financeFormData.summaryInCategories;
  }
}
